app.component("operationNoteHeader", {
	templateUrl: "app/src/js/components/operationNote/operationNoteHeader/operationNoteHeader.html",
	controller: "operationNoteHeaderController",
	bindings: {
		data: "=",
		header: "="
	},
});

app.controller("operationNoteHeaderController", [
	"$scope",
	"CurrentPatient",
	"$window",
	function ($scope, CurrentPatient, $window) {
		this.$onInit = function () {
			this.CP = CurrentPatient;
		};


		$scope.backDashboard = function(){
			$window.history.back();
		}
	},
]);
